import React, { useState, useRef } from 'react';
import { InstagramIcon, FacebookIcon, LinkedinIcon, Music2Icon, MapPinIcon, PhoneIcon, MailIcon, MessageCircleIcon, CalendarIcon, ChevronRightIcon, SendIcon, LoaderIcon } from 'lucide-react';
import emailjs from '@emailjs/browser';
// TODO: Replace these with your actual EmailJS credentials
const EMAILJS_SERVICE_ID = 'service_doctorecommerce';
const EMAILJS_TEMPLATE_ID = 'template_moving_form';
const EMAILJS_PUBLIC_KEY = 'YOUR_PUBLIC_KEY';
type MiniFormStatus = 'idle' | 'sending' | 'success' | 'error';
export function Footer() {
  const miniFormRef = useRef<HTMLFormElement>(null);
  const [miniStatus, setMiniStatus] = useState<MiniFormStatus>('idle');
  const handleMiniSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!miniFormRef.current) return;
    setMiniStatus('sending');
    try {
      await emailjs.sendForm(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, miniFormRef.current, EMAILJS_PUBLIC_KEY);
      setMiniStatus('success');
      miniFormRef.current.reset();
    } catch {
      setMiniStatus('error');
    }
  };
  const scrollToContact = () => {
    document.getElementById('contacto')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <footer className="w-full bg-carbon border-t border-gold/20" data-id="element-123">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 md:py-16" data-id="element-124">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8" data-id="element-125">
          {/* Column 1 — Brand */}
          <div data-id="element-126">
            <img src="https://cdn.magicpatterns.com/uploads/cFE4co4RErLtqWASz4pjSH/IMG_6635.jpg" alt="Doctor Ecommerce" className="w-20 h-auto object-contain mb-4 rounded" data-id="element-127" />
            <p className="text-gold font-semibold text-base italic mb-3" data-id="element-128">
              La cura para negocios estancados.
            </p>
            <p className="text-muted text-sm leading-relaxed mb-5" data-id="element-129">
              En Doctor Ecommerce no gestionamos redes, operamos sistemas de
              adquisición de alto rendimiento. Con sede estratégica en Tampa,
              Florida, servimos a dueños de negocios en todo Estados Unidos.
            </p>
            <div className="flex items-center gap-4" data-id="element-130">
              <a href="#" aria-label="Instagram" className="text-gold hover:text-gold/70 transition-colors" data-id="element-131">
                <InstagramIcon className="w-5 h-5" data-id="element-132" />
              </a>
              <a href="#" aria-label="Facebook" className="text-gold hover:text-gold/70 transition-colors" data-id="element-133">
                <FacebookIcon className="w-5 h-5" data-id="element-134" />
              </a>
              <a href="#" aria-label="LinkedIn" className="text-gold hover:text-gold/70 transition-colors" data-id="element-135">
                <LinkedinIcon className="w-5 h-5" data-id="element-136" />
              </a>
              <a href="#" aria-label="TikTok" className="text-gold hover:text-gold/70 transition-colors" data-id="element-137">
                <Music2Icon className="w-5 h-5" data-id="element-138" />
              </a>
            </div>
          </div>

          {/* Column 2 — Servicios */}
          <div data-id="element-139">
            <h3 className="text-gold font-bold text-sm tracking-widest uppercase mb-5" data-id="element-140">
              Servicios
            </h3>
            <ul className="space-y-2.5 text-muted text-sm" data-id="element-141">
              <li className="hover:text-light transition-colors cursor-pointer" data-id="element-142">
                Meta Ads · Google Ads · TikTok Ads · YouTube Ads
              </li>
              <li className="hover:text-light transition-colors cursor-pointer" data-id="element-143">
                Email · SMS · Retargeting Automatizado
              </li>
              <li className="hover:text-light transition-colors cursor-pointer" data-id="element-144">
                Automatización con IA para Ventas 24/7
              </li>
              <li className="hover:text-light transition-colors cursor-pointer" data-id="element-145">
                Funnels Quirúrgicos por Industria
              </li>
              <li className="hover:text-light transition-colors cursor-pointer" data-id="element-146">
                Blindaje Digital & Anti-Ban
              </li>
              <li className="hover:text-light transition-colors cursor-pointer" data-id="element-147">
                PR Digital & Posicionamiento en Medios
              </li>
              <li className="hover:text-light transition-colors cursor-pointer" data-id="element-148">
                CRM & Data Tracking Avanzado
              </li>
              <li className="hover:text-light transition-colors cursor-pointer" data-id="element-149">
                Video Marketing IA · SEO · Branding
              </li>
              <li className="hover:text-light transition-colors cursor-pointer" data-id="element-150">
                Gestión de Reputación · Google Maps
              </li>
              <li className="hover:text-light transition-colors cursor-pointer" data-id="element-151">
                Diseño Web · Landing Pages · CRO
              </li>
            </ul>
          </div>

          {/* Column 3 — Recursos */}
          <div data-id="element-152">
            <h3 className="text-gold font-bold text-sm tracking-widest uppercase mb-5" data-id="element-153">
              Recursos
            </h3>
            <ul className="space-y-3 text-muted text-sm" data-id="element-154">
              <li className="flex items-center gap-2 hover:text-light transition-colors cursor-pointer" data-id="element-155">
                <ChevronRightIcon className="w-4 h-4 text-gold/60" data-id="element-156" /> Blog de
                Estrategia
              </li>
              <li className="flex items-center gap-2 hover:text-light transition-colors cursor-pointer" data-id="element-157">
                <ChevronRightIcon className="w-4 h-4 text-gold/60" data-id="element-158" /> Casos de
                Éxito
              </li>
              <li className="flex items-center gap-2 hover:text-light transition-colors cursor-pointer" data-id="element-159">
                <ChevronRightIcon className="w-4 h-4 text-gold/60" data-id="element-160" /> Política
                de Privacidad
              </li>
              <li className="flex items-center gap-2 hover:text-light transition-colors cursor-pointer" data-id="element-161">
                <ChevronRightIcon className="w-4 h-4 text-gold/60" data-id="element-162" /> Términos y
                Condiciones
              </li>
            </ul>
          </div>

          {/* Column 4 — Contacto Directo */}
          <div data-id="element-163">
            <h3 className="text-gold font-bold text-sm tracking-widest uppercase mb-5" data-id="element-164">
              Contacto Directo
            </h3>
            <ul className="space-y-3 text-muted text-sm mb-6" data-id="element-165">
              <li className="flex items-start gap-2.5" data-id="element-166">
                <MapPinIcon className="w-4 h-4 text-gold shrink-0 mt-0.5" data-id="element-167" />
                1001 WATER ST, TAMPA FL 33602
              </li>
              <li className="flex items-center gap-2.5" data-id="element-168">
                <PhoneIcon className="w-4 h-4 text-gold shrink-0" data-id="element-169" />
                <a href="tel:4028720639" className="hover:text-light transition-colors" data-id="element-170">
                  (402) 872-0639
                </a>
              </li>
              <li className="flex items-center gap-2.5" data-id="element-171">
                <MailIcon className="w-4 h-4 text-gold shrink-0" data-id="element-172" />
                <a href="mailto:doctor.ecommerceus@gmail.com" className="hover:text-light transition-colors break-all" data-id="element-173">
                  doctor.ecommerceus@gmail.com
                </a>
              </li>
            </ul>

            <a href="https://wa.me/14028720639" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 w-full bg-emerald text-white font-bold text-sm py-3 rounded-md hover:bg-emerald/90 transition-colors mb-3" data-id="element-174">
              <MessageCircleIcon className="w-4 h-4" data-id="element-175" />
              Habla con un Especialista
            </a>

            <button onClick={scrollToContact} className="flex items-center justify-center gap-2 w-full bg-gold text-carbon font-bold text-sm py-3 rounded-md hover:bg-gold/90 transition-colors" data-id="element-176">
              <CalendarIcon className="w-4 h-4" data-id="element-177" />
              RESERVAR DIAGNÓSTICO
            </button>
          </div>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="border-t border-border" data-id="element-178">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8 md:py-10" data-id="element-179">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start" data-id="element-180">
            {/* Partners */}
            <div data-id="element-181">
              <p className="text-gold/70 text-xs font-bold tracking-widest uppercase mb-4" data-id="element-182">
                PARTNERS CERTIFICADOS Y TECNOLOGÍA DE ÉLITE
              </p>
              <div className="flex flex-wrap gap-3" data-id="element-183">
                <div className="bg-white/90 text-carbon text-xs font-bold px-4 py-2.5 rounded-md" data-id="element-184">
                  Meta Business Partner
                </div>
                <div className="bg-white/90 text-carbon text-xs font-bold px-4 py-2.5 rounded-md" data-id="element-185">
                  Google Ads
                </div>
                <div className="bg-white/90 text-carbon text-xs font-bold px-4 py-2.5 rounded-md" data-id="element-186">
                  Certified
                </div>
                <div className="bg-white/90 text-carbon text-xs font-bold px-4 py-2.5 rounded-md" data-id="element-187">
                  Shopify
                </div>
              </div>
            </div>

            {/* Mini Contact Form */}
            <div data-id="element-188">
              <p className="text-gold/70 text-xs font-bold tracking-widest uppercase mb-4" data-id="element-189">
                ¿QUIERES QUE TE CONTACTEMOS?
              </p>
              <form ref={miniFormRef} onSubmit={handleMiniSubmit} className="flex flex-col sm:flex-row flex-wrap gap-2" data-id="element-190">
                <input type="text" name="nombre" required placeholder="Tu Nombre" className="bg-surface border border-border text-light text-sm rounded-md py-2.5 px-3 flex-1 min-w-0 focus:outline-none focus:border-gold transition-colors placeholder:text-muted/50" data-id="element-191" />
                <input type="email" name="email" required placeholder="Tu Email" className="bg-surface border border-border text-light text-sm rounded-md py-2.5 px-3 flex-1 min-w-0 focus:outline-none focus:border-gold transition-colors placeholder:text-muted/50" data-id="element-192" />
                <input type="tel" name="telefono" required placeholder="Tu Teléfono" className="bg-surface border border-border text-light text-sm rounded-md py-2.5 px-3 flex-1 min-w-0 focus:outline-none focus:border-gold transition-colors placeholder:text-muted/50" data-id="element-193" />
                <input type="text" name="compania" required placeholder="Nombre de tu Empresa" className="bg-surface border border-border text-light text-sm rounded-md py-2.5 px-3 flex-1 min-w-0 focus:outline-none focus:border-gold transition-colors placeholder:text-muted/50" data-id="element-194" />
                <button type="submit" disabled={miniStatus === 'sending'} className="bg-gold text-carbon font-bold text-sm px-5 py-2.5 rounded-md hover:bg-gold/90 transition-colors disabled:opacity-60 flex items-center justify-center gap-1.5 shrink-0" data-id="element-195">
                  {miniStatus === 'sending' ? <LoaderIcon className="w-4 h-4 animate-spin" data-id="element-196" /> : <>
                      <SendIcon className="w-3.5 h-3.5" data-id="element-197" />
                      ENVIAR
                    </>}
                </button>
              </form>
              {miniStatus === 'success' && <p className="text-emerald text-xs mt-2" data-id="element-198">
                  ¡Enviado! Te contactaremos pronto.
                </p>}
              {miniStatus === 'error' && <p className="text-red-400 text-xs mt-2" data-id="element-199">
                  Error al enviar. Intenta de nuevo.
                </p>}
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-border/50" data-id="element-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-5" data-id="element-201">
          <p className="text-muted/50 text-xs text-center" data-id="element-202">
            © 2025 Doctor Ecommerce. Todos los derechos reservados. | Tampa,
            Florida
          </p>
        </div>
      </div>
    </footer>;
}